import { Component, EventEmitter, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { map, Observable, Subject } from 'rxjs';
import { ActionButtonEvent } from 'src/app/layout/action-button-toolbar/action-button-toolbar.component';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import { NewDeliveryDialogComponent } from './new-delivery-dialog/new-delivery-dialog.component';
import { ApproveDeliveryDialogComponent } from './approve-delivery-dialog/approve-delivery-dialog.component';
import { StockingServiceService } from '../stocking-service.service';
import { NotificationService } from 'src/app/shared/notification.service';
import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';

@Component({
  selector: 'app-extra-delivery',
  templateUrl: './extra-delivery.component.html',
  styleUrl: './extra-delivery.component.css'
})
export class ExtraDeliveryComponent implements OnInit {

  onEdit = new EventEmitter<ActionButtonEvent>();
  onApprove = new EventEmitter<ActionButtonEvent>();

  rowActionButtons: { icon: string; tooltip: string; eventEmitter: EventEmitter<ActionButtonEvent>; }[] = [
    {
      icon: 'edit'
      , tooltip: 'Edit',
      eventEmitter: this.onEdit
    },
    {
      // The table renders one set of buttons for every row, so this is shown on
      // all of them and tells you why it does nothing on the rows it cannot act
      // on — only a portal order awaiting approval has anything to approve.
      icon: 'fact_check',
      tooltip: 'Approve / reject portal order',
      eventEmitter: this.onApprove
    }
  ];


  dataSource$: Observable<any[]>;

  columnSettings: ColumnSetting[] = [

    {
      columnId: 'week',
      name: 'Week'
    },
    {
      columnId: 'date',
      name: 'Date'
    },
    {
      columnId: 'deliveryNumber',
      name: '#'
    },
    {
      columnId: 'systemName',
      name: 'System'
    },
    {
      columnId: 'sourceLabel',
      name: 'Source'
    },
    {
      columnId: 'typeDelivery',
      name: 'Type'
    },
    {
      columnId: 'productsString',
      name: 'Products'
    },
    {
      columnId: 'name',
      name: 'Creator'
    },
    {
      columnId: 'status',
      name: 'Status'
    }
  ]


  constructor(
    public dialog: MatDialog,
    private stockingService: StockingServiceService,
    private notificationService: NotificationService
  ) {
    // this.onAddDelivery()

    // this.rowActionButtons = [
    //   {
    //     icon: 'edit',
    //     tooltip: 'Edit',
    //     eventEmitter: new EventEmitter<ActionButtonEvent>()
    //   },
    //   {
    //     icon: 'delete',
    //     tooltip: 'Delete',
    //     eventEmitter: new EventEmitter<ActionButtonEvent>()
    //   }
    // ];

    this.onEdit.subscribe((event) => {
      console.log(event);
      const dialogRef = this.dialog.open(NewDeliveryDialogComponent, {
        width: '800px',
        data: {
          title: 'Edit Extra Delivery',
          action: 'edit',
          delivery: event.eventData
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          // this.getRelevantMenu();
        }
      });
    });

    this.onApprove.subscribe((event) => {
      const delivery = event.eventData;

      // Nothing to approve on an operator's own delivery, or on a portal order
      // that has already been handled.
      if (delivery.source !== 'portal') {
        this.notificationService.showNotification('warning', 'Only orders placed in the customer portal need approval');
        return;
      }
      if (delivery.status !== 'Pending approval') {
        this.notificationService.showNotification('warning', `This order is already ${delivery.status}`);
        return;
      }

      this.dialog.open(ApproveDeliveryDialogComponent, {
        width: '640px',
        data: { delivery }
      });
    });

    this.dataSource$ = this.stockingService.getExtraDelivery$().pipe(
      map((data) => {
        return data.map((item) => {
          // console.log(item);
          return {
            ...item,
            date: moment(item.date).format('DD.MM.YYYY'),
            productsString: item.products.map((product) => {
              return product.amount + " x " + product.product
            }).join(', '),
            status: item.status ? item.status : 'unknown',
            sourceLabel: item.source === 'portal' ? 'Portal' : 'Frigg',
          }
        }).sort((a, b) => {
          // Orders a customer is waiting on come first — they are the only rows
          // on this page that need someone to act before the day arrives.
          const aPending = a.status === 'Pending approval';
          const bPending = b.status === 'Pending approval';
          if (aPending !== bPending) return aPending ? -1 : 1;
          return moment(b.date, 'DD.MM.YYYY').diff(moment(a.date, 'DD.MM.YYYY'))
        })
      })
    );
  }
  ngOnInit(): void {
    // setTimeout(() => {
    //   this.dummyData$.next(this.dummyData);
    // }, 1000);
  }

  onAddDelivery() {
    const dialogRef = this.dialog.open(NewDeliveryDialogComponent, {
      width: '800px',
      data: {
        title: 'Add Extra Delivery',
        action: 'add'
      }
    });
  }

  // getRelevantMenu(){

    
  //   this.menusService.getMenu$(    ).subscribe((menus) => {
  //     menus.forEach((menu) => {
  //       if (menu.locked) {
  //         this.lockedWeeks.push(menu.week + "-" + menu.year)
  //       }
  //     })
  //   })
  // }

  import() {
      // TODO: Implement import functionality
      console.log("Import not implemented yet");
  }

}
